import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSubaruComponent } from './simple-icons-subaru.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSubaruComponent ],
    exports:      [ SimpleIconsSubaruComponent ],
    bootstrap:    []
})
export class SimpleIconsSubaruModule {}
